import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api`;

const auth = token => ({ headers: token ? { Authorization: `Bearer ${token}` } : {} });

// -- floor designer ------------------------------------------------------------

/** Every table's geometry. Readable by anyone signed in — captains work off this view. */
export const getLayout = token =>
  axios.get(`${API}/floor/layout`, auth(token)).then(r => r.data);

/**
 * Save positions. All-or-nothing on the server: a half-applied floor plan is worse
 * than a rejected one, so an unknown table id rejects the whole request.
 */
export const saveLayout = (tables, token) =>
  axios.put(`${API}/floor/layout`, { tables }, auth(token)).then(r => r.data);

// -- combos --------------------------------------------------------------------

/** Combo menu items with their components resolved, plus components_total and savings. */
export const listCombos = token =>
  axios.get(`${API}/combos`, auth(token)).then(r => r.data);

export const createCombo = (body, token) =>
  axios.post(`${API}/combos`, body, auth(token)).then(r => r.data);

/**
 * One combo, components resolved. Read before editing rather than trusting the list
 * row: PUT /components replaces the whole list, so editing a copy that went stale
 * while the page was open would silently drop whatever another terminal added.
 */
export const getCombo = (comboId, token) =>
  axios.get(`${API}/combos/${comboId}`, auth(token)).then(r => r.data);

export const replaceComboComponents = (comboId, components, token) =>
  axios.put(`${API}/combos/${comboId}/components`, { components }, auth(token)).then(r => r.data);

/** Deactivates rather than deleting — order_items reference the menu item. */
export const deactivateCombo = (comboId, token) =>
  axios.delete(`${API}/combos/${comboId}`, auth(token)).then(r => r.data);
